module.exports = __webpack_public_path__ + "static/img/Presentation-of-the-logo-on-the-Arc-de-Triomphe.9d10777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Presentation-of-the-logo-on-the-Arc-de-Triomphe.jpg
// module id = Mzve
// module chunks = 0